import AxiosRestAPI from "../../../../util/AxiosRestAPI";
import {V1SupplierRevisionIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";

class SupplierRevisionEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.SupplierRevision-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.SupplierRevision-001";

        let fk = {};

        AxiosRestAPI({
            method: "GET",
            url: "t1/v1/supplier_revisions",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1SupplierRevisionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default SupplierRevisionEnterpriseComponent;